
<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box">
					<label for="start-date">企业名称：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.invocieTitle"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">发票号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.code"
							name="start-date"></span>
				</div>
                <div class="order-query-form-box">
					<label for="start-date">快递单号：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.mailNo"
							name="start-date"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">状态：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.state" placeholder="请选择" class="stSetSelect">
							<el-option v-for="item in waybillStateList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:showPage="togglePage"
				:selectType="true"
				:showSummary="true" 
				:count-data="dataTotal" 
				:loading="loading" 
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
			</common-table>
		</div>
		<st-dialog :title="titleDialog" :toggleStDialog="toggleStDialog" @closeDialog="toggleStDialog=false"
			@saveDialog="saveDialogForm">
			<div class="st-dialog-content">
				<ul class="st-dialog-form clearfix" v-if="sendToggle">
					<li>
						<div class="st-dialog-item-title"><span class="tips">*</span>快递公司：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="sendParam.mailCompany" /></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><span  class="tips">*</span>快递单号：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="sendParam.mailNo" /></div>
					</li>
					<li>
						<div class="st-dialog-item-title">邮寄备注：</div>
						<div class="st-dialog-item-input"><textarea class="remarkBox" cols="10" rows="10"
							v-model="sendParam.mailRemark"></textarea></div>
					</li>
				</ul>
				<ul class="st-dialog-form clearfix "  v-else>
					<li>
						<div class="st-dialog-item-title"><span class="tips">*</span> 发票号：</div>
						<div class="st-dialog-item-input"><input type="text" style="width:80%" v-model="code" /></div>
					</li>
				</ul>
			</div>
		</st-dialog>
	</div>
</template>
<script>
	import stDialog from '../../components/StDialog'
	export default {
		name: 'MarginManage',
		props: [],
		components: { stDialog },
		data() {
			return {
				dataList: [], //数据列表
				dataTotal: {},
				loading: false,
				titleDialog:this.sendToggle?'邮寄':'开票',
				pageConfig: {
					total: 0,
					pageSize: 100,
					currentPage: 1,
				},
				bottomHandleArr: [
					{
						label: '邮寄',
						type: 'success',
						handler: () => this.sendInvoice()
					},
					{
						label: '导出',
						type: 'success',
						handler: () => this.exportTable()
					}
				],
				tableColumns: [
					{
						type: 'selection',
						fixed: 'left',
					},{
						key: '',
						title: '操作',
						operate:true,
						width:'80',
						align:'center',
						setBtns:(row,index)=>{
							return [
								{
									label:'开票',
									disabled:row.state==='SUBMITTED'|| row.state==='COMPLETE'?false:true,
									handler: (row,index) => this.createInvoice(row)
								}
							]
						}
					},
					{
						title: '发票号',
						key: 'code'
					},
					{
						title: '开票运单数',
						width:'100',
						align:'center',
						key: 'relevanceQuantity',
					},
					{
						title: '开票总额',
						width:'100',
						key: 'totalFee',
					},
					{
						title: '状态',
						width:'100',
						key: 'stateDesc',
					},
					{
						title: '企业名称',
						key: 'invocieTitle',
					},
					{
						title: '税号',
						key: 'taxpayerIdNumber',
					},
					
					{
						title: '企业电话',
						key: 'companyContact',
					},
					{
						title: '开户行名称',
						key: 'bankName',
					},
					{
						title: '开户行账号',
						key: 'bankAccount',
					},
					{
						title: '收件人',
						width:'120',
						key: 'contactSubject',
					},
					{
						title: '手机电话',
						width:'150',
						key: 'contactPhone',
					},
					{
						title: '地址',
						key: 'address',
					},
					{
						title: '快递单号',
						key: 'mailNo',
					},
					{
						title: '快递公司',
						key: 'mailCompany',
					},
					
				],
				togglePage:false,
				orderForm: {
					invocieTitle: null,
					code:null,
					mailNo: null,
					state: '', //SUBMITTED=已提交/MAILED=已邮寄/REJECTED=已驳回
				},
				selectedList: [],// 选中的列表
				toggleStDialog: false,// 弹窗
				sendToggle:false,
				waybillStateList: [{
					value: '',
					label: '全部'
				},{
					value: 'SUBMITTED',
					label: '已提交'
				},{
					value: 'COMPLETE',
					label: '已开具'
				},{
					value: 'MAILED',
					label: '已邮寄'
				}, {
					value: 'REJECTED',
					label: '已驳回'
				}],
				sendParam:{
					mailNo:'',
					mailCompany:'',
					mailRemark:''
				},
				code:'',
				createOrder:{}
			}
		},
		created() { },
		methods: {
			selectionChange(val) {
				this.selectedList = val;
			},
			sizeChange(size) {
				this.pageConfig.currentPage = 1
				this.pageConfig.pageSize = size
				this.searchList()
			},
			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage
				this.searchList()
			},
			searchList(flag) {
				this.loading = true
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if(flag) pages.current = 1;
				let orderForm = this.orderForm;
				Object.assign(orderForm, pages)
				
				this.$server.financial.invoiceCount(orderForm, (res) => {
					this.dataTotal = res.data
				})
				this.$server.financial.invoicePage(orderForm, (res) => {
					this.loading = false
					if (res.code == 0) {
						this.dataList = res.data.records;
						this.pageConfig.total = res.data.total;
						this.pageConfig.currentPage = res.data.current;
						if(res.data.total>0){
							this.togglePage=true;
						}
					}
				})
			},
			// 开票
			createInvoice(row) {
				this.createOrder=row;
				this.code=row.code
				this.toggleStDialog=true;
				this.sendToggle=false;
			},
			// 邮寄
			sendInvoice(){
				if(this.selectedList.length<1){
					return	this.$toast.stMessage('请选择数据', false)
				}
				this.toggleStDialog=true;
				this.sendToggle=true
			},
			saveDialogForm() {
				if(this.sendToggle){
					let idsObj=this.selectedList.reduce((obj,item)=>{
						if(item.state!=='COMPLETE'){
							obj.errNum++
						}else{
							obj.ids.push(item.id);
						}
						return obj;
					},{ids:[],errNum:0})

					if(idsObj.errNum>0){
						this.toggleStDialog=false;
						return this.$toast.stMessage(`有${idsObj.errNum}条数据不是已开具状态，请选择已开具状态的数据`, false)
					}else if(!this.sendParam.mailCompany){
						return this.$toast.stMessage(`请填写快递公司`, false)
					}else if(!this.sendParam.mailNo){
						return this.$toast.stMessage(`请填写快递单号`, false)
					}
					this.$server.financial.invoiceMain({
						ids:idsObj.ids,
						...this.sendParam
					},(res)=>{
						this.$toast.stMessage('邮寄成功', true)
						this.toggleStDialog=false;
						this.searchList()
					})
				}else{
					if(!this.code){
						return	this.$toast.stMessage('发票号不可为空', false)
					}
					this.$server.financial.completeInvice({
						id:this.createOrder.id,
						code:this.code
					},(res)=>{
						this.$toast.stMessage('开票成功', true)
						this.toggleStDialog=false;
						this.searchList()
					})
				}
			},
			// 导出
			exportTable() {
				let that = this;
				if (this.dataList.length == 0) {
					that.$toast.stMessage('暂无订单', true)
					return;
				}
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				const sendData = {
					...this.orderForm,
					exportColumnFiledNames: this.tableColumns.map((item) => {
						return  item.key
					}).filter(item => {
						return item && item.trim()
					})
				}
				Object.assign(sendData, pages)
				this.$server.common.exportTable('/invoice/pageExcel', sendData, (res) => {
					console.log('导出成功')
				})

			},
		},
		mounted() {

		}
	}

</script>
<style scoped>
	.margin-manage {
		width: 100%;
		height: auto;
	}

	.data-table {
		margin-bottom: 8px;
	}
	.query-setting-box{
		/* height: 108px; */
	}
	.query-setting-box-left {
		flex-grow: 0;
	}

	.order-query-form-box-right {
		margin-left: 24px;
	}

	.remarkBox {
		width: 100%;
		height: 100px;
		resize: none;
		display: block;
		margin: 1px 0;
		border: 1px solid #DCDCDC;
	}

	.st-dialog-item-input {
		margin-top: 2px;
	}
	.st-dialog-form{
		padding: 0 20px;
	}
	.st-dialog-form li {
		float: none;
		width: 100%;
		
	}

	.st-dialog-form{
	width: 406px;
}
.st-dialog-form li {
	width: 156px;
	padding: 13px 0;
}
.st-dialog-form li:nth-child(even){
	float: right;
}
.st-dialog-form li:nth-child(odd){
	float: left;
}
.st-dialog-form li:last-child{
	float:  left;;
	width: 100%;
}
.st-dialog-form .st-dialog-item-title{
	height: 20px;
	line-height: 20px;
}
.st-dialog-form .st-dialog-item-title i{
	color: #FF5B3E;
}
.st-dialog-form .st-dialog-item-input input{ 
	width: 156px;
	height: 30px;
	text-indent: 8px;
	border-radius: 2px;
	border: 1px solid #DCDCDC;
	box-sizing: border-box;
}
.tips{
	color: #FF5B3E;
	vertical-align: middle;
	margin-right: 5px;
}
</style>